<template>
  <div >
    <side-menu />
    <loading-screen v-if="loadingScreen" />
    <section class="container">
      <template>
        <a-steps direction="horizontal" :current="activeStep" size="small" v-if="stepsResponsible()">
          <a-step />
          <a-step />
          <a-step v-for="(step, x) in formSteps" v-bind:key="x" />
          <a-step />
        </a-steps>
        <a-steps direction="vertical" :current="activeStep" size="small" v-if="!stepsResponsible()">
          <a-step />
          <a-step />
          <a-step v-for="(step, x) in formSteps" v-bind:key="x" />
          <a-step />
        </a-steps>
        <div class="card">
          <kit-number v-if="activeStep === 0" @next="nextStep" /> <!-- Digita o numero do kit -->
          <privacy-policy v-if="activeStep === 1" @next="nextStep" /> <!-- Aceita as politicas de privacidade -->
          <kit-orientation :shipping_type="shipping_type" v-if="activeStep === 2" @next="forceNextStep" /><!-- orientações de coleta -->
          <data-kit-health-customer
            v-if="activeStep >= 3 && activeStep - 2 <= totalFormSteps && !!kit_type"
            :kit_id="kit_id"
            :kit_type="kit_type"
            :kit="form.kit_number"
            :step="activeStep"
            @next="nextStep($event);scheduleActiveStep=true"
            @formNextStep="formNextStep"
            @setFormSteps="setFormSteps"
          /><!-- formulario do kit -->
          <data-kit-schedule
            :shipping_type="shipping_type"
			      :tag_type="tag_type"
            :kit="form.kit_number"
            v-if="scheduleActiveStep"
            @next="nextStep" />
        </div>
        {{activeStep}}
      </template>
    </section>
  </div>
</template>

<script>
  import {POST_KIT} from "../../services/kit";

  import DataKitCustomer from "../../components/RegisterKitSteps/DataKitCustomer";
  import KitNumber from "../../components/RegisterKitSteps/KitNumber"
  import DataKitHealthCustomer from "../../components/RegisterKitSteps/DataKitHealthCustomer";
  import DataKitSchedule from "../../components/RegisterKitSteps/DataKitSchedule";
  import KitOrientation from '../../components/RegisterKitSteps/KitOrientation';
  import PrivacyPolicy from "../../components/RegisterKitSteps/PrivacyPolicy";

  export default {
    name: "RegisterKit",
    components: {PrivacyPolicy, KitNumber, DataKitCustomer, DataKitHealthCustomer, DataKitSchedule, KitOrientation},
    data: () => ({
		loadingScreen: false,
		activeStep: 0,
		formSteps: [],
		totalFormSteps: 3,
		shipping_type: 0,
    scheduleActiveStep: false,
		currentFormStep: null,
		form: {},
		kit_id: null,
		kit_type: null,
		tag_type: null,
    }),
    methods: {
		setFormSteps(steps) {
			this.formSteps = steps;
			this.totalFormSteps += steps.length + 1;
		},
		formNextStep(to = true) {
			if(to)
				this.activeStep += 1;
			else
				this.activeStep -= 1;
		},
    forceNextStep() {
      if(this.form.verified && this.activeStep === 0){
				this.activeStep += 2;
			}else{
				this.activeStep += 1;
			}
    },
		nextStep(obj) {
      console.log("step ativo", this.activeStep);
      this.tag_type = obj.tag_type || "";

      let f = this.form;
      this.form = {...f, ...obj};
      if (this.activeStep <= 2) {
        this.activeStep += 1;
        this.handleSubmit();
        return;
      }

      if(this.shipping_type && this.shipping_type == 3) {
        this.activeStep += 1;
      }else	if(this.form.verified && this.activeStep === 0) {
				this.activeStep += 2;
			}else{
				this.activeStep += 2;
			}
      console.log(this.activeStep);
			this.handleSubmit();
			},
			handleSubmit() {
				POST_KIT(this.form).then(
				resp => {
					this.kit_id = resp.data.id;
					this.kit_type = resp.data.kit_type_id;
          this.shipping_type = resp.data.order_owner.partner_place.partner.shipping_type || null;
				}
				);
			},
			stepsResponsible() {
				let width = window.screen.width;
				return width >= 490;
			}
		}
  }
</script>

<style scoped>
  @import "./register-kit.scss";
  @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/views/RegisterKit/RegisterKit.vue